import React from "react";

const PoolMcGregorOutline = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="134.037"
      height="295.08"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 134.037 295.08"
      xmlSpace="preserve"
      className="clickable"
    >
      <g
        transform="translate(-1227.16 -830.388)"
      >
        <path
          fill="rgba(0,0,0,0)"
          className="object-glow"
          stroke="#ff5c97"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="5"
          d="M1302 854c-9.33 1.867-15.4 3.967-18.2 6.3-2.8 2.333-9.1 22.4-18.9 60.2-9.8 37.8-14.47 57.867-14 60.2.47 2.333 1.4 3.5 2.8 3.5s3.5 1.4 6.3 4.2c2.8 2.8 5.13 3.967 7 3.5l2.8-.7c-.47 3.733-.93 7.467-1.4 11.2-.93 7.47 0 12.37 2.8 14.7s4.43 4.43 4.9 6.3c.47 1.87 0 7.93-1.4 18.2s2.33 20.07 11.2 29.4c8.87 9.33 14 15.63 15.4 18.9 1.4 3.27 2.1 7.47 2.1 12.6v7.7c.7-.23 1.4-.47 2.1-.7 1.4-.47 3.03-2.33 4.9-5.6 1.87-3.27 2.8-8.4 2.8-15.4s2.33-13.53 7-19.6c4.67-6.07 6.77-26.83 6.3-62.3-.47-35.467 0-59.267 1.4-71.4 1.4-12.133 3.73-22.167 7-30.1s4.9-15.633 4.9-23.1c0-7.467-.47-13.067-1.4-16.8-.93-3.733-2.1-5.833-3.5-6.3-1.4-.467-1.87-1.633-1.4-3.5.23-.933.47-1.867.7-2.8l-9.1-.7c-6.07-.467-13.77.233-23.1 2.1z"
          opacity="1"
        ></path>
      </g>
    </svg>
  );
}

export default PoolMcGregorOutline;
